import { useContext, useEffect, useState } from 'react';
import { SliderInfo } from '../../../../../interface/Slider';
import { GameContext } from '../../../../../contexts/GameContext';
import { Values } from '../../../../../interface/Values';
import { Data } from '../../../../../interface/Data';
import { AppContext } from '../../../../../contexts/AppContext';

interface Props {
  min: number;
  max: number;
  value: number;
  pos: number[];
  sliderInfo: SliderInfo,
  asset: keyof Values | keyof Data | "energy";
}

const ParameterScale = ({ min, max, value, pos, sliderInfo, asset }: Props) => {
  const { defaultValues } = useContext(AppContext);
  const [fontColor, setFontColor] = useState<string>("black");

  useEffect(() => {
      if (defaultValues) setFontColor(defaultValues["theme"]["color_one"])
  })

  const { interfaceParams } = useContext(GameContext);

  const processPosition = () => {
    return (Math.max(0, Math.min(100, (value - min) * (100 / (max - min))))).toString()
  }

  return interfaceParams ? (
    <g transform={`translate(${pos[0]} ${pos[1]})`}>
      <defs>
        {(asset.toString() === "thermal_comfort" || asset.toString() === "visual_comfort") ?
          <linearGradient id={`gradient-${asset.toString()}`}>
            <stop offset={(interfaceParams["bars"][asset]["gradient"][0]["threshold"] * 100).toString() + "%"} stopColor={interfaceParams["bars"][asset]["gradient"][0]["color"]} />
            <stop offset={(interfaceParams["bars"][asset]["gradient"][1]["threshold"] * 100 - 5).toString() + "%"} stopColor={interfaceParams["bars"][asset]["gradient"][0]["color"]} />
            <stop offset={(interfaceParams["bars"][asset]["gradient"][1]["threshold"] * 100 + 5).toString() + "%"} stopColor={interfaceParams["bars"][asset]["gradient"][1]["color"]} />
            <stop offset={(interfaceParams["bars"][asset]["gradient"][2]["threshold"] * 100 - 5).toString() + "%"} stopColor={interfaceParams["bars"][asset]["gradient"][1]["color"]} />
            <stop offset={(interfaceParams["bars"][asset]["gradient"][2]["threshold"] * 100 + 5).toString() + "%"} stopColor={interfaceParams["bars"][asset]["gradient"][2]["color"]} />
            <stop offset={(interfaceParams["bars"][asset]["gradient"][3]["threshold"] * 100 - 5).toString() + "%"} stopColor={interfaceParams["bars"][asset]["gradient"][2]["color"]} />
            <stop offset={(interfaceParams["bars"][asset]["gradient"][3]["threshold"] * 100 + 5).toString() + "%"} stopColor={interfaceParams["bars"][asset]["gradient"][3]["color"]} />
            <stop offset={(interfaceParams["bars"][asset]["gradient"][4]["threshold"] * 100 - 5).toString() + "%"} stopColor={interfaceParams["bars"][asset]["gradient"][3]["color"]} />
            <stop offset={(interfaceParams["bars"][asset]["gradient"][4]["threshold"] * 100 + 5).toString() + "%"} stopColor={interfaceParams["bars"][asset]["gradient"][4]["color"]} />
            <stop offset={"100%"} stopColor={interfaceParams["bars"][asset]["gradient"][4]["color"]} />
          </linearGradient> :
          <linearGradient id={`gradient-${asset.toString()}`}>
            <stop offset={(interfaceParams["bars"][asset]["gradient"][0]["threshold"] * 100).toString() + "%"} stopColor={interfaceParams["bars"][asset]["gradient"][0]["color"]} />
            <stop offset={(interfaceParams["bars"][asset]["gradient"][1]["threshold"] * 100 - 5).toString() + "%"} stopColor={interfaceParams["bars"][asset]["gradient"][0]["color"]} />
            <stop offset={(interfaceParams["bars"][asset]["gradient"][1]["threshold"] * 100 + 5).toString() + "%"} stopColor={interfaceParams["bars"][asset]["gradient"][1]["color"]} />
            <stop offset={(interfaceParams["bars"][asset]["gradient"][2]["threshold"] * 100 - 5).toString() + "%"} stopColor={interfaceParams["bars"][asset]["gradient"][1]["color"]} />
            <stop offset={(interfaceParams["bars"][asset]["gradient"][2]["threshold"] * 100 + 5).toString() + "%"} stopColor={interfaceParams["bars"][asset]["gradient"][2]["color"]} />
            <stop offset={"100%"} stopColor={interfaceParams["bars"][asset]["gradient"][2]["color"]} />
          </linearGradient>}
      </defs>
      <text
        x={0} y={12} fontSize="8" fontFamily="ArialMT, Arial" >{sliderInfo.legend.low}</text>
      <text x={100} y={12} fontSize="8" fontFamily="ArialMT, Arial" textAnchor='end'>{sliderInfo.legend.high}</text>
      <rect
        x="0"
        y="0"
        rx="1"
        ry="1"
        width="100"
        height="5"
        fill={`url(#${`gradient-${asset.toString()}`})`}
      />
      <rect x={processPosition()} y="-2.5" width="4" height="10" strokeWidth={0.3} fill="black" stroke="rgb(0, 0, 0)" pointerEvents="all" />
      <text className='value-label' x={processPosition()} y="-7.5" width="4" height="10" textAnchor='middle' strokeWidth={0.3} fill={fontColor} stroke={fontColor} pointerEvents="all">{value < 1 || asset === "temp" ? (value.toFixed(1) === "-0.0" ? "0.0": value.toFixed(1)) : value.toFixed(0)}</text>

    </g>
  ) : null
}

export default ParameterScale